import React, { useState } from 'react';
import Joyride, { Step } from 'react-joyride';
import { fetchPost } from '../../api/common';
import { Profile } from '@par/shared/types/player';

const joyrideStepsInit: Step[] = [
  {
    target: 'body',
    placement: 'center',
    title: 'Welcome to PAR!',
    content: `PAR offers a wide variety of features. From solo to multiplayer play, dailies, leaderboards, training, user-submitted questions, and more! Don't be overwhelmed, we'll help you jump right into a game. Later, take your time and explore the site.`,
    showSkipButton: true,
    showProgress: true,
  },
  {
    target: '.jr-top-nav-profile',
    title: 'Your profile',
    content:
      'Go to your profile page by clicking here. Your username is auto-generated. You can update it to something else if you would like.',
    showProgress: true,
  },
  {
    target: '.valorant-container',
    title: 'The PLAY button',
    content: 'Click this button to open the game menu and play a game',
    showProgress: true,
  },
];

type PropTypes = {
  profile: Profile;
  updateProfileCompletedTour: (completed: boolean) => void;
};

export const JoyrideComponent = ({
  profile,
  updateProfileCompletedTour,
}: PropTypes) => {
  const [joyrideSteps, setJoyrideSteps] = useState<Step[]>(joyrideStepsInit);

  const joyrideCallback = async (e: any) => {
    if (
      ((e.lifecycle === 'complete' && e.status === 'finished') ||
        e.status === 'skipped') &&
      profile
    ) {
      await fetchPost('/profile/completed-tour', profile);
      updateProfileCompletedTour(true);
    }
  };

  return (
    <Joyride
      run={false}
      // run={!profile.completedTour}
      steps={joyrideSteps}
      continuous={true}
      locale={{ last: 'Finish' }}
      callback={joyrideCallback}
      styles={{
        options: {
          arrowColor: '#232323',
          backgroundColor: '#232323',
          primaryColor: '#AA4586',
          textColor: '#fff',
        },
      }}
    />
  );
};
